"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interceptNetwork = void 0;
const fetch_1 = require("./fetch");
const xhr_1 = require("./xhr");
const interceptNetwork = (emitter) => {
    if (window.fetch) {
        const handler = (0, fetch_1.createFetchApiHandler)(emitter);
        window.fetch = new Proxy(window.fetch, handler);
    }
    if (window.XMLHttpRequest) {
        const handler = (0, xhr_1.createXHRHandler)(emitter);
        window.XMLHttpRequest.prototype.open = new Proxy(window.XMLHttpRequest.prototype.open, handler.open);
        window.XMLHttpRequest.prototype.send = new Proxy(window.XMLHttpRequest.prototype.send, handler.send);
        window.XMLHttpRequest = new Proxy(window.XMLHttpRequest, 
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        handler.construct);
    }
};
exports.interceptNetwork = interceptNetwork;
